import styled from 'styled-components'
import { Skeleton } from '~/components/shared'

export const Container = styled.div`
  position: relative;
  margin: 20px;
  height: calc(100vh - 78px);
`

export const BackButtonContainer = styled.div`
  position: relative;
  width: 100%;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 20%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: translateY(-100%);
  }
`
export const MainHealthProcedureDetailsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 90vh;
  max-height: 100%;
`
export const MessageError = styled.p`
  font-size: 0.8rem;
  color: ${props => props.theme.colors.color545e6c};
  text-align: center;
  padding-top: 50%;
`
export const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
`
export const SkeletonItem = styled(Skeleton).attrs(props => ({
  baseColor: props.theme.colors.colorf2f7ff
}))`
  margin-bottom: 10px;
  border-radius: 2px;
  margin-right: 8px;
`
export const ContainerSkeletonButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
